<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px"> 
      <div class="messenger-box">
        <div>
          <label for="facebook-id" class="input-label">Nhập Zalo OAID tại đây:</label>
          <!-- OAID -->
          <input id="facebook-id" class="input-field" placeholder="Nhập Zalo OAID"
            [(ngModel)]="objectChoosing.staticdata.zaloFollowAttributes.data_oaid" />
          <button mat-raised-button color="primary" class="btn-update"
            (click)="updateStaticData()">Cập nhật</button>
        </div>
        <p>
          Hướng dẫn cách lấy OA ID của Zalo doanh nghiệp tại
          <span (click)="showModal()" class="guide">đây</span>
        </p>
      </div>
      <nz-modal [(nzVisible)]="isVisible"
        [nzStyle]="{ maxHeight: '80vh', top: '32px', overflowY : 'scroll', 'paddingBottom': '0' }" [nzWidth]="'70%'"
        (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
        <ng-container *nzModalContent>
          <img src="/assets/root/images/system/imgs/cach_lay_oaid.jpg" style="width: auto; height: auto" />
        </ng-container>
      </nz-modal>
      <!-- Hiển thị số lượng bài viết của zalo, min 1, max 5 -->
      <div class="messenger-box">
        <label class="input-label">Số lượng bài viết hiển thị:</label> <br>
        <nz-input-number [(ngModel)]="objectChoosing.staticdata?.zaloFollowAttributes.data_article"
          (nzBlur)="updateStaticData()" [nzMin]="1" [nzMax]="5" [nzStep]="1"></nz-input-number>
      </div>
      <!-- Hiển thị ảnh bìa của zalo, có/không -->
      <div class="messenger-box">
        <label class="input-label">Hiện ảnh bìa bảng tin:</label> <br>
        <nz-radio-group [(ngModel)]="objectChoosing.staticdata?.zaloFollowAttributes.data_cover"
          (ngModelChange)="updateStaticData()">
          <label nz-radio nzValue="yes">Có</label>
          <label nz-radio nzValue="no">Không</label>
        </nz-radio-group>
      </div>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">

    <ul nz-menu nzMode="inline" >
      <!-- Cấu hình thông số cơ bản của button-->
      <li
        nz-submenu
        nzTitle="{{'hien_thi'| translate}}"
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
                  </app-hide-show-config>
      </li>
    </ul>
    
    <div class="messenger-box">
      <div>
        <label for="facebook-id" class="input-label">Nhập Zalo OAID tại đây:</label>
        <!-- OAID -->
        <input id="facebook-id" class="input-field" placeholder="Nhập Zalo OAID"
          [(ngModel)]="objectChoosing.staticdata.zaloFollowAttributes.data_oaid" />
        <button mat-raised-button color="primary" class="btn-update"
          (click)="updateStaticData()">Cập nhật</button>
      </div>
      <p>
        Hướng dẫn cách lấy OA ID của Zalo doanh nghiệp tại
        <span (click)="showModal()" class="guide">đây</span>
      </p>
    </div>
    <nz-modal [(nzVisible)]="isVisible"
      [nzStyle]="{ maxHeight: '80vh', top: '32px', overflowY : 'scroll', 'paddingBottom': '0' }" [nzWidth]="'70%'"
      (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
      <ng-container *nzModalContent>
        <img src="/assets/root/images/system/imgs/cach_lay_oaid.jpg" style="width: auto; height: auto" />
      </ng-container>
    </nz-modal>
    <!-- Hiển thị số lượng bài viết của zalo, min 1, max 5 -->
    <div class="messenger-box">
      <label class="input-label">Số lượng bài viết hiển thị:</label> <br>
      <nz-input-number [(ngModel)]="objectChoosing.staticdata?.zaloFollowAttributes.data_article"
        (nzBlur)="updateStaticData()" [nzMin]="1" [nzMax]="5" [nzStep]="1"></nz-input-number>
    </div>
    <!-- Hiển thị ảnh bìa của zalo, có/không -->
    <div class="messenger-box">
      <label class="input-label">Hiện ảnh bìa bảng tin:</label> <br>
      <nz-radio-group [(ngModel)]="objectChoosing.staticdata?.zaloFollowAttributes.data_cover"
        (ngModelChange)="updateStaticData()">
        <label nz-radio nzValue="yes">Có</label>
        <label nz-radio nzValue="no">Không</label>
      </nz-radio-group>
    </div>

  </ng-container>

</div>